module.exports = __webpack_public_path__ + "static/media/logo-big.a4f6937b.png";